import { useState } from 'react';
import nacanacaLogo from '../../../assets/logo.webp';

const fieldClass = 'mt-2 w-full border border-[#3f3550] bg-[#100d17] px-4 py-3 text-sm text-[#f4effb] outline-none transition focus:border-[#bd78ef] focus:ring-2 focus:ring-[#9e56d8]/25';

export default function AdminLogin({ onLogin, error, isLoading }) {
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('');
  const isLocal = ['localhost', '127.0.0.1'].includes(window.location.hostname);

  const submit = (event) => {
    event.preventDefault();
    onLogin(username.trim(), password);
  };

  return (
    <main className="admin-grid min-h-screen bg-[#09070d] px-5 py-10 text-[#eee8f5] sm:py-16">
      <section className="mx-auto grid min-h-[80vh] w-full max-w-5xl items-center gap-10 lg:grid-cols-[1.1fr_.9fr]">
        <div className="max-w-xl">
          <img src={nacanacaLogo} alt="Ñaca Ñaca" className="w-32" />
          <p className="mt-10 font-mono text-[10px] uppercase tracking-[.28em] text-[#b88bd5]">Acceso restringido · Operación</p>
          <h1 className="mt-3 font-display text-6xl uppercase leading-[.86] text-white sm:text-7xl">Consola<br /><span className="text-[#bd78ef]">del ritual</span></h1>
          <p className="mt-6 max-w-md border-l border-[#76508d] pl-4 text-sm leading-6 text-[#bcb1c8]">Administra lo que verá el público sin editar código ni reiniciar una partida en curso.</p>
        </div>

        <form onSubmit={submit} className="relative border border-[#3f3550] bg-[#121019]/95 p-6 shadow-[12px_14px_0_#050407] sm:p-8">
          <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-[#713a95] via-[#c17af0] to-[#d6b367]" />
          <p className="font-mono text-[10px] uppercase tracking-[.22em] text-[#9f90ae]">Identificación de operador</p>
          <h2 className="mt-2 font-display text-4xl uppercase text-[#f5edf9]">Abrir tablero</h2>
          <label className="mt-7 block text-xs font-bold text-[#d8cedf]" htmlFor="admin-username">Usuario</label>
          <input id="admin-username" autoComplete="username" value={username} onChange={(event) => setUsername(event.target.value)} className={fieldClass} required />
          <label className="mt-5 block text-xs font-bold text-[#d8cedf]" htmlFor="admin-password">Contraseña</label>
          <input id="admin-password" type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} className={fieldClass} required autoFocus />
          {error && <p className="mt-4 border-l-2 border-[#ef7f8f] bg-[#2b1219] px-3 py-2 text-xs text-[#ffd8de]" role="alert">{error}</p>}
          {isLocal && <p className="mt-4 font-mono text-[10px] leading-5 text-[#8f829c]">Acceso local inicial: admin / nacanaca-local</p>}
          <button type="submit" disabled={isLoading} className="mt-7 w-full border border-[#d4adf0] bg-[#77429c] px-5 py-3.5 text-xs font-black uppercase tracking-[.16em] text-white shadow-[4px_4px_0_#08050b] transition active:translate-x-0.5 active:translate-y-0.5 disabled:opacity-50">
            {isLoading ? 'Verificando…' : 'Entrar a la consola'}
          </button>
        </form>
      </section>
    </main>
  );
}
